import configuration from 'config/config';

const BASE_URLS = {
	PORTAL_USER_INFO: `${configuration?.api.PORTAL_DOMAIN}`,
	RB_URL: `${configuration?.api.RB_DOMAIN}`,
	RB_PREVIEW_URL: `${configuration?.api.RB_PREVIEW_DOMAIN}`,
	RB_CUSTOM_DATASET_URL: `${configuration?.api.RB_CUSTOM_DATASET}`,
	RB_SCHEDULE_URL: `${configuration?.api.RB_SCHEDULE_DOMAIN}`,
	RB_DOWNLOAD_URL: `${configuration?.api.RB_DOWNLOAD_DOMAIN}`,
	CP_PROFILE_URL: `${configuration?.api.CP_PROFILE_DOMAIN}`,
	CP_USER_LIST_URL: `${configuration?.api.CP_USER_DOMAIN}`
};

const APIURLPATH = {
	FIRST_TIME_USER: `${BASE_URLS.RB_URL}/user/firstTimeUser`,
	PREVIEW: `${BASE_URLS.RB_PREVIEW_URL}/data/preview`,
	ROW_COUNT: `${BASE_URLS.RB_PREVIEW_URL}/data/rowCount`,
	CUSTOM_DATASET_ROW_COUNT: `${BASE_URLS.RB_PREVIEW_URL}/data/customDatasetRowCount`,
	SAVE_DRAFT: `${BASE_URLS.RB_SCHEDULE_URL}/draft/saveDraft`,
	VIEW_TYPE: `${BASE_URLS.RB_URL}/templates/view?type=`,
	CUSTOM_ATTRIBUTES_TYPE: `${BASE_URLS.RB_URL}/templates/customAttributes?type=`,
	DEPARTMENT: `${BASE_URLS.RB_URL}/merchant/departments?`,
	RUN_QUERY_REQUEST_OBJ: `${BASE_URLS.RB_URL}/templates/runQueryRequestObject?subTemplateId=`,
	CANNED_TEMPLATES: `${BASE_URLS.RB_URL}/templates/cannedTemplates?type=`,
	REPORT_VIEW: `${BASE_URLS.RB_SCHEDULE_URL}/dashboard/reports/view`,
	REPORT_SHARED_WITH_ME: `${BASE_URLS.RB_SCHEDULE_URL}/dashboard/reports/sharedWithMe`,
	DOWNLOAD_FILE: `${BASE_URLS.RB_DOWNLOAD_URL}/download/file`,
	DELETE_REPORT: `${BASE_URLS.RB_SCHEDULE_URL}/dashboard/report/delete`,
	RUN_NOW: `${BASE_URLS.RB_SCHEDULE_URL}/schedule/runNow/`,
	// USER_SEARCH: `${BASE_URLS.CP_USER_LIST_URL}/companies/users/search?page=0&pageSize=20&search=`,
	REPORT_SHARE: `${BASE_URLS.RB_SCHEDULE_URL}/dashboard/report/share/`,
	REPORT_UNSHARED: `${BASE_URLS.RB_SCHEDULE_URL}/dashboard/report/unshared/`,
	LEAVE_REPORT: `${BASE_URLS.RB_SCHEDULE_URL}/dashboard/report/leaveReport/`,
	SUUPLIER_USER_SEARCH: `${BASE_URLS.CP_USER_LIST_URL}/companies/users/contextual-search?persona=SUPPLIER&search=`,
	MERCHANT_USER_SEARCH: `${BASE_URLS.CP_USER_LIST_URL}/companies/users/contextual-search?persona=MERCHANT&search=`,
	DV_USER_SEARCH: `${BASE_URLS.CP_USER_LIST_URL}/companies/users/contextual-search?persona=ASSOCIATE&search=`,
	ALL_DRAFTS: `${BASE_URLS.RB_SCHEDULE_URL}/draft/allDrafts`,
	REFRESH_TIME: `${BASE_URLS.RB_SCHEDULE_URL}/schedule/refreshTime`,
	SCHEDULE_SAVE: `${BASE_URLS.RB_SCHEDULE_URL}/schedule/save`,
	SCHEDULE_UPDATE: `${BASE_URLS.RB_SCHEDULE_URL}/schedule/update`,
	PORTAL_USER_INFO: `${BASE_URLS.PORTAL_USER_INFO}`,
	MODIFY_NAME: `${BASE_URLS.RB_SCHEDULE_URL}/draft/modifyName/`,
	DELETE_DRAFT: `${BASE_URLS.RB_SCHEDULE_URL}/draft/deleteDraft/`,
	FILTER_VALUES: `${BASE_URLS.RB_PREVIEW_URL}/filter/values/`,
	CUSTOM_ATTRIBUTES: `${BASE_URLS.RB_URL}/templates/customAttributes/`,
	CAN_USER_CREATE_REPORT: `${BASE_URLS.RB_SCHEDULE_URL}/schedule/validate/canUserCreateReport`,
	ITEM_SHARE: `${BASE_URLS.RB_URL}/user/firstTimeUser/itemShare`,
	PINNED_ATTRIBUTE: `${BASE_URLS.RB_URL}/user/pinnedAttributes`,
	CUSTOM_DATASET_DETAILS: `${BASE_URLS.RB_CUSTOM_DATASET_URL}/template?type=`,
	CUSTOM_DATASET: `${BASE_URLS.RB_CUSTOM_DATASET_URL}/user`,
	VISUAL_HIERARCHY: `${BASE_URLS.RB_PREVIEW_URL}/filter/hierarchy/traits`,
	CUSTOM_DATASET_DELETE: `${BASE_URLS.RB_CUSTOM_DATASET_URL}/user/delete`,
	CALENDER_ROLL_DIM: `${BASE_URLS.RB_PREVIEW_URL}/time/calendarRollDim`,
	LOGGING_ERRORS: `${BASE_URLS.RB_URL}/logging/ui-errors`
};

export default APIURLPATH;
